import React, { useMemo } from 'react';
import { ReferenceArrayInput } from 'react-admin';
import { Grid } from '@material-ui/core/';

import GridInput from '../../../core/components/inputs/GridInput';

const validateInvestors = value => {
  if (Array.isArray(value) && value.length < 1) {
    return 'At least one Investor must be selected';
  }
  return undefined;
};

const InvestorsGridInput = props => {
  const { choices } = props;

  //Preselecting the investors:
  //First lets select only investors which are not associated with an Family
  //That is necessary because orphan investors can be added to an Family.
  const preselectedChoices = useMemo(() => {
    return choices.filter(item => {
      return !item.organizationId;
    });
  }, [choices]);

  return preselectedChoices.length > 0 ? (
    <GridInput
      {...props}
      choices={preselectedChoices}
      optionTextLabel={'Investor Name'}
      optionValueLabel={'Investor ID'}
      additionalColumns={[
        { label: 'Status', name: 'status', isStatusColumn: true }
      ]}
    />
  ) : (
    <span>There are no Investors to be displayed</span>
  );
};

const AddExistingInvestorSummary = () => {
  return (
    <div>
      <Grid container spacing={1}>
        <Grid item sm={12}>
          <ReferenceArrayInput
            label="To add Investor to this Family, select one or multiple items from the list of the Investors below."
            optionText="Investor Name"
            optionValue="Investor ID"
            resource="investors"
            reference="investors"
            source="investors"
            validate={[validateInvestors]}
            perPage={-1}
            sort={{ field: 'name', order: 'ASC' }}
          >
            <InvestorsGridInput />
          </ReferenceArrayInput>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddExistingInvestorSummary;
